import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
//help
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
//page links  
export default function Help() {
    const location = useLocation();
    const navigate = useNavigate();
    const handleGoBack = () => {
  if (window.history.length > 1) {
    navigate(-1); // Go back
  } else {
    navigate('/'); // No history, go to home
  }
};

    return (
        <div>
            <div className="status-bar">
                <div className="container_size">
                    <div className="status-bar_size">
                        <div className='left_body'>
                            <VscArrowLeft onClick={handleGoBack} className='back_arrow_btn' />
                        </div>
                        <div className='name-bar-body'>Help Center</div>
                        <div className='right_body'>
                            <div
                            
                                className={`help-button-icon ${location.pathname === '/help' ? 'active' : ''}`}
                                title="Help Center"
                            >
                                {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}

                                <span className="button-text">Help</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className='app_header_height'></div>
            <div className="container_roots">

                <Helmet>
                    <title>EditorTask - Help Center</title>

                    <meta name="description" content="Explore freelance opportunities, post job tasks, or showcase your creative work on EditorTask. Connecting job seekers and employers across India." />
                    <meta name="keywords" content="job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work" />
                    <meta name="author" content="editortask.com" />
                    <meta name="robots" content="index, follow" />

                    <meta property="og:title" content="EditorTask - India’s Trusted Platform for Jobs & Creative Talent" />
                    <meta property="og:description" content="Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers." />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://www.editortask.com/" />
                    <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

                </Helmet>

                <div className="container_size">
                    <h1 className="contact-title">Help Center</h1>
                </div>
            </div>
        </div>
    );
}
